import { render, staticRenderFns } from "./MessagesBadge.vue?vue&type=template&id=5356308e"
import script from "./MessagesBadge.vue?vue&type=script&lang=js"
export * from "./MessagesBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports